import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function getUserByFacebookId (facebookId) {
  const database = firebase.firestore()
  return database.collection('users').where('facebook_id', '==', facebookId).get()
    .then(res => {
      let user = null
      res.forEach(item => {
        user = item.data()
        user.id = item.id
      })
      return user
    })
}
function createUser (user) {
  const database = firebase.firestore()
  return database.collection('users').add(user)
    .then(res => {
      return res
    })
}
function updateUser (user) {
  const database = firebase.firestore()
  return new Promise(resolve => {
    resolve(database.collection('users').doc(user.id).update(user))
  })
    .then(res => {
      return true
    })
    .catch(err => console.log(err))
}

export default {
  getUserByFacebookId,
  createUser,
  updateUser
}
